export var NullLogger = {
  debug: function debug() {},
  error: function error() {},
  info: function info() {},
  trace: function trace() {},
  warn: function warn() {}
};
export function getNullLogger() {
  return NullLogger;
}